"use strict";
// ATTENTION: DO NOT ADD REQUIRED() FLAG TO CLAIM SCHEMA
// Required fields are enforced at the end of claim-schema.ts `const submittedClaimSchema = claimSchema.options({ presence: 'required' });`
// This will ensure that all fields not explicitly marked as optional() are required
Object.defineProperty(exports, "__esModule", { value: true });
exports.listingSchema = void 0;
var claim_domain_1 = require("@hobt/claim-domain");
var constants_1 = require("@hobt/constants");
var common_1 = require("../../../common");
var utils_1 = require("../utils");
var Joi = require('joi').extend(require('@joi/date'));
exports.listingSchema = Joi.object({
    appraisalDate: Joi.date()
        .format('YYYY-MM-DD')
        .min('1996-01-01') // Appraisal Date cannot be earlier than 1996-01-01. Please enter a valid date.
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_BEFORE_1996, 'Appraisal Date'),
    })
        .max('now') // Appraisal Date cannot be a future date. Please enter a valid date.
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Appraisal Date'),
    })
        .custom(function (value, helper) {
        var claim = helper.state.ancestors[2];
        if (utils_1.hasFirstAndSecondListingProperty(claim, 'appraisalDate')) {
            Joi.assert(claim.listing[1].appraisalDate, Joi.date().greater(claim.listing[0].appraisalDate), constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_2, 'Appraisal Date'));
        }
        return value;
    }),
    appraisalValue: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false }),
    approvedLenderListingDate: Joi.date()
        .format('YYYY-MM-DD')
        .min('1996-01-01') // Listing Date cannot be earlier than 1996-01-01. Please enter a valid date.
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_BEFORE_1996, 'Listing Date'),
    })
        .max('now') // 'Listing Date cannot be a future date. Please enter a valid date.'
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Listing Date'),
    })
        .optional()
        .when(Joi.ref('/detail.typeOfClaim'), {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.required().label(constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DEFICIENCY_SALE_VALUE_REQUIRED, 'approvedLenderListingDate')),
        otherwise: Joi.optional(),
    })
        // TODO: Find the proper type for helper
        .custom(function (value, helper) {
        var claim = helper.state.ancestors[2];
        if (utils_1.hasFirstAndSecondListingProperty(claim, 'approvedLenderListingDate')) {
            Joi.assert(claim.listing[1].approvedLenderListingDate, Joi.date().greater(claim.listing[0].approvedLenderListingDate), constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_2, 'Listing Date'));
        }
        return value;
    }),
    approvedLenderListingExpiryDate: Joi.date()
        .format('YYYY-MM-DD')
        .min('1996-01-01') // Listing Expiry Date cannot be earlier than 1996-01-01. Please enter a valid date.
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_BEFORE_1996, 'Listing Expiry Date'),
    })
        .when('/detail.typeOfClaim', {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.date().format('YYYY-MM-DD'),
        otherwise: Joi.date()
            .format('YYYY-MM-DD')
            .max('now') // Listing Expiry Date cannot be a future date. Please enter a valid date.
            .rule({
            message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Listing Expiry Date'),
        }),
    })
        .custom(function (value, helper) {
        var listing = helper.state.ancestors[0];
        if (listing && listing.approvedLenderListingDate && listing.approvedLenderListingExpiryDate) {
            Joi.assert(listing.approvedLenderListingExpiryDate, Joi.date().greater(listing.approvedLenderListingDate), constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_4));
        }
        return value;
    })
        .custom(function (value, helper) {
        var claim = helper.state.ancestors[2];
        if (utils_1.hasFirstAndSecondListingProperty(claim, 'approvedLenderListingExpiryDate')) {
            Joi.assert(claim.listing[1].approvedLenderListingExpiryDate, Joi.date().greater(claim.listing[0].approvedLenderListingExpiryDate), constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_2, 'Listing Expiry Date'));
        }
        return value;
    })
        .custom(function (value, helper) {
        var claim = helper.state.ancestors[2];
        if (helper.state.path[1] === 1 &&
            utils_1.hasSecondListing(claim) &&
            claim.listing[1].approvedLenderListingDate != null &&
            claim.listing[1].approvedLenderListingExpiryDate != null) {
            var limit = common_1.getDateIn90Days(claim.listing[1].approvedLenderListingDate);
            Joi.assert(claim.listing[1].approvedLenderListingExpiryDate, Joi.date().max(limit), constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_3));
        }
        return value;
    })
        .optional(),
    approvedLenderListingPeriod: Joi.number()
        .integer()
        .min(0)
        .max(2147483648)
        .options({ convert: false }),
    approvedLenderListPrice: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when(Joi.ref('/detail.typeOfClaim'), {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.required().label(constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DEFICIENCY_SALE_VALUE_REQUIRED, 'approvedLenderListPrice')),
        otherwise: Joi.optional(),
    })
        .optional(),
    comparativeMarketAnalysisDate: Joi.date()
        .format('YYYY-MM-DD')
        .optional()
        .when(Joi.ref('/detail.typeOfClaim'), {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.required().label(constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DEFICIENCY_SALE_VALUE_REQUIRED, 'comparativeMarketAnalysisDate')),
        otherwise: Joi.optional(),
    })
        .custom(function (value, helper) {
        var claim = helper.state.ancestors[2];
        if (utils_1.hasFirstAndSecondListingProperty(claim, 'comparativeMarketAnalysisDate')) {
            Joi.assert(claim.listing[1].comparativeMarketAnalysisDate, Joi.date().greater(claim.listing[0].comparativeMarketAnalysisDate), constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_2, 'CMA Date'));
        }
        return value;
    }),
    comparativeMarketAnalysisValue: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .optional()
        .when(Joi.ref('/detail.typeOfClaim'), {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.required().label(constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DEFICIENCY_SALE_VALUE_REQUIRED, 'comparativeMarketAnalysisValue')),
        otherwise: Joi.optional(),
    }),
    minimumAcceptableSalePrice: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .optional()
        .when(Joi.ref('/detail.typeOfClaim'), {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.required().label(constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DEFICIENCY_SALE_VALUE_REQUIRED, 'minimumAcceptableSalePrice')),
        otherwise: Joi.optional(),
    }),
    revisedListPrice: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .invalid(Joi.ref('approvedLenderListPrice')) // Revised List Price cannot be the same as the Lender List Price. Please enter a valid Revised List Price.
        .precision(2)
        .options({ convert: false })
        .optional()
        .when(Joi.ref('/detail.typeOfClaim'), {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.required().label(constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DEFICIENCY_SALE_VALUE_REQUIRED, 'revisedListPrice')),
        otherwise: Joi.valid(null, '')
            .optional()
            .label(constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DEFICIENCY_SALE_VALUE_FORBIDDEN, 'revisedListPrice')),
    })
        .custom(function (value, helper) {
        var claim = helper.state.ancestors[2];
        if (utils_1.hasFirstAndSecondListingProperty(claim, 'revisedListPrice')) {
            Joi.assert(claim.listing[1].revisedListPrice, Joi.number().less(claim.listing[0].revisedListPrice), constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_1));
        }
        return value;
    })
        .messages({
        'any.invalid': constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_0),
    }),
});
exports.default = { listingSchema: exports.listingSchema };
